<div
    class="apt-loading-indicator-wrapper"
    [ngClass]="[
      showBackdrop
        ? 'apt-loading-indicator-backdrop'
        : 'apt-loading-indicator-backdrop-transparent',
      fullPage ? 'page-loading-indicator' : '',
      blockSection ? 'block-section-indicator' : ''
    ]"
>
  <div class="apt-loading-indicator" data-test-selector="apt-loading-indicator" [ngStyle]="{ 'min-height': minHeight }">
    <i
      class="apt-loading-indicator-icon fa fa-circle-notch fa-spin"
      [ngClass]="[size ? size : '']"
    ></i>
    <span
      *ngIf="message"
      class="apt-loading-indicator-message ps-2"
      data-test-selector="apt-loading-indicator-message"
      [ngClass]="[size ? size : '']"
      [innerHTML]='message'></span
    >
  </div>
</div>
